import { useEffect, useState } from 'react';

function useTheme() {
  const [theme, setTheme] = useState(() => {
    // 1. Préférence sauvegardée
    const saved = localStorage.getItem('theme');
    if (saved) return saved;
    // 2. Préférence système
    return window.matchMedia('(prefers-color-scheme: light)').matches
      ? 'light' : 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  return { theme, toggle: () => setTheme((t) => (t === 'light' ? 'dark' : 'light')) };
}

export default useTheme;
